<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Comissionamento"
                @click.stop="confirmarExcluirComissionamento()"
                v-if="$temAcessoView('API-COMISSOES-03')"
            ></i>
        </span>
    </div>
</template>

<script>
import ComissionamentosServicos from './comissionamentosServicos'

export default {
    props: {
        comissionamento: {
            type: Object,
            default: () => ({})
        }
    },

    emits: ['obterComissoesAtualizadas'],

    methods: {
        confirmarExcluirComissionamento() {
            this.mostrarAlerta()
        },

        mostrarAlerta() {
            this.$swal({
                title: 'Comissionamento',
                html: `Confirma a exclusão da comissão?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.excluirComissionamento()
                }
            })
        },

        excluirComissionamento() {
            this.$store.dispatch('addRequest')

            ComissionamentosServicos
                .excluirComissao(this.comissionamento.comissaoId, this.$route.params.contratoId)
                .then((response) => {
                    if (response && response.success) {
                        this.$toast.success(
                            'Registro excluído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterComissoesAtualizadas')
                    } else {
                        this.erros = response.erros
                    }

                    this.$store.dispatch('removeRequest')
                })
        }
    },

}
</script>
